module.exports = __webpack_public_path__ + "img/13.01ff2898.png";